/**
 * 学習画面表示の型
 * TODO: 今後学習画面実装時に必要な型はここに追記
 */
import { StrokePoint } from '@/models/StrokePoint'
import { InputItem } from '@/models/inputItem'
import { AnswerFormat } from '@/const/AnswerFormats'
import { DrawingDataType } from '@/models/drawingDataModel'

// 手書き入力時にMyScriptに渡す言語タイプ
export type LangType = 'MATHML' | 'en_US' | 'ja_JP' | null

// ダイアログ付き入力フィールドの区分
export class InputDialogType {
  static readonly TEGAKI = 'tegaki'
  static readonly KEYBOARD = 'keyboard'
}

// テキスト、テキストエリア、プルダウン、手書き、キーボード入力形式で使用する問題情報の型
export type StudyQuestionData = {
  // 入力値
  inputValue: string
  // 前文テキスト
  beforeText: string
  // 後文テキスト
  afterText: string
  // 手書き/キーボード入力時、入力フィールドの区分
  inputType?: InputDialogType
  // 手書き入力時、MyScriptに渡す言語タイプ
  lang?: LangType
  // 手書き入力時、保存済みストロークポイント
  savedStrokes?: StrokePoint[][]
  // プルダウン入力時、選択肢
  selectItems?: InputItem[]
}

// 単一選択、複数選択、並び替え入力形式で使用する問題情報の型
export type StudyQuestionChoiceData = {
  // 入力値
  inputValue: string | string[]
  // 選択肢
  choiceItems: InputItem[]
  // 単一選択、複数選択時のラベル表示不可フラグ
  labelNotDisplayable?: boolean
  // 並び替え時の選択解除可能フラグ
  canDeselectedOrder?: boolean
}

// 問題情報の型
export type StudyProblem = {
  // ID
  id: number
  // 問題番号
  problemNumber: number
  // 画像URL
  imageUrls: string[]
  // 設問情報
  questions: StudyQuestion[]
  // 経過時間
  duration: number
}

// 設問情報の型
export type StudyQuestion = {
  // ID
  id: number
  // 設問番号テキスト
  questionNumberText: string | null
  // 指示文
  indicativeText: string
  // 入力形式
  answerFormat: AnswerFormat
  // テキスト、テキストエリア、プルダウン、手書き、キーボード入力形式で使用する問題情報
  questionDatas?: StudyQuestionData[]
  // 単一選択、複数選択、並び替え入力形式で使用する問題情報
  questionChoiceData?: StudyQuestionChoiceData
  // 画像URL
  imageUrls: string[]
  // 経過時間
  duration: number
}

// 音声情報の型（音声情報が存在しない場合は全項目が設定不要）
export type StudyAudioInfoType = {
  // 音声URL
  url?: string
  // 音声再生回数
  count?: number
  // 音声再生対象の問題ID（音声が問題に紐付く場合はここに値が入る）
  problemId?: number
  // 音声再生対象の設問ID（音声が設問に紐付く場合はここに値が入る）
  questionId?: number
}

// メモ情報の型
export type StudyQuestionMemoType = {
  // 設問ID
  questionId: number
  // エンコードされたメモ画像情報
  src: string
  // ベクター描画データ
  drawingData?: DrawingDataType | null
}

// 学習表示種別コード
export class StudyTypeCode {
  static readonly QUESTION_AND_ANSWER = 'question_and_answer_display'
  static readonly ANSWER_ONLY_ALL = 'answer_only_display_all'
  static readonly ANSWER_ONLY_PARTS = 'answer_only_display_parts'
}

// 学習表示種別
export type StudyType =
  | typeof StudyTypeCode.QUESTION_AND_ANSWER
  | typeof StudyTypeCode.ANSWER_ONLY_ALL
  | typeof StudyTypeCode.ANSWER_ONLY_PARTS
  | null

/** 授業モードコード */
export const STUDY_MODE_CODE = Object.freeze({
  normal: 'TJ',
  recommend: 'LV',
  // adjust: 'RI',
} as const)

/** 授業モード名 */
export const STUDY_MODE_NAME = Object.freeze({
  TJ: '通常',
  LV: 'レコメンド',
  // RI: 'アジャスト',
} as const)

/** 授業モードコード一覧型 */
export type StudyModeCodeType = (typeof STUDY_MODE_CODE)[keyof typeof STUDY_MODE_CODE]
